/* Herlamora recently viewed — records the visited product handle in
   localStorage and fills the slider with the previously viewed
   products. Each card is fetched via the Section Rendering API BY
   FILENAME (?section_id=herlamora-recently-viewed): the section
   rendered in another product's context carries that product's card
   as the hidden [data-rv-seed] item. Filename rendering (with schema
   defaults) is deliberate — template-scoped ids differ per product
   template, and products live on many templates (ribbed, crystal,
   compression, …), so id-based fetches would skip cross-template
   products. */

if (!customElements.get('herlamora-recently-viewed')) {
  customElements.define(
    'herlamora-recently-viewed',
    class HerlamoraRecentlyViewed extends HTMLElement {
      connectedCallback() {
        const KEY = 'herlamora:recently-viewed';
        const SECTION_FILE = 'herlamora-recently-viewed';
        const limit = parseInt(this.dataset.limit || '8', 10);
        const current = this.dataset.currentHandle || '';
        const row = this.querySelector('[data-rv-row]');

        let list = [];
        try {
          list = JSON.parse(localStorage.getItem(KEY) || '[]');
        } catch (error) {
          list = [];
        }
        if (!Array.isArray(list)) list = [];
        list = list.filter((handle) => typeof handle === 'string' && handle !== '');

        const show = list.filter((handle) => handle !== current).slice(0, limit);

        // record the current visit AFTER computing what to show, so the
        // product never recommends itself
        if (current) {
          const next = [current].concat(list.filter((handle) => handle !== current)).slice(0, 24);
          try {
            localStorage.setItem(KEY, JSON.stringify(next));
          } catch (error) {
            /* storage full/blocked — tracking is best-effort */
          }
        }

        if (show.length === 0 || !row) return;

        Promise.all(
          show.map((handle) =>
            fetch('/products/' + encodeURIComponent(handle) + '?section_id=' + SECTION_FILE)
              .then((response) => (response.ok ? response.text() : null))
              .then((html) => {
                if (!html) return null;
                const doc = document.createElement('div');
                doc.innerHTML = html;
                const seed = doc.querySelector('[data-rv-seed]');
                if (!seed || !seed.firstElementChild) return null;
                const item = document.createElement('li');
                item.className = 'grid__item';
                while (seed.firstChild) item.appendChild(seed.firstChild);
                return item;
              })
              .catch(() => null)
          )
        ).then((items) => {
          const cards = items.filter(Boolean);
          if (cards.length === 0) return;
          cards.forEach((card) => row.appendChild(card));
          // the shared slider element's ResizeObserver on the scroller
          // recalculates arrows + indicator once the cards land
          this.hidden = false;
        });
      }
    }
  );
}
